import React from "react"
import Select from "react-select"
import { Controller, useController } from "react-hook-form"
import { FormSelectProps } from "."

export function MultiSelect({ name, label, placeholder, options, control }: FormSelectProps) {
  const { fieldState } = useController({ name, control })
  const { error } = fieldState

  return (
    <div className="w-full">
      <label className="text-gray-8e text-sm">{label} </label>
      <Controller
        name={name}
        control={control}
        render={({ field: { value, onChange } }) => (
          <Select
            isMulti
            placeholder={placeholder}
            options={options}
            value={options.filter((option) => value?.includes(option.value))}
            onChange={(options) => onChange(options?.map((options) => options.value))}
            styles={{
              control: (props) => ({
                display: "flex",
                padding: "8px",
                borderColor: error ? "#ef2547" : "#ececec",
                boxShadow: "0 0 0 #ececec",
                borderBottom: "1px solid #8E8E8E",
                minHeight: 0,
                fontSize: "14px",
              }),
              input: (props) => ({
                ...props,
                margin: 0,
                paddingTop: 0,
                paddingBottom: 0,
              }),
              placeholder: (props) => ({
                ...props,
                color: "#979797",
                marginLeft: 0,
                marginRight: 0,
                fontSize: "12px",
              }),
              dropdownIndicator: (props) => ({
                ...props,
                padding: 0,
              }),
              valueContainer: (props) => ({
                ...props,
                padding: "0 5px 0 0",
              }),
              indicatorSeparator: (props) => ({
                display: "none",
              }),
              option: (props, { isSelected }) => ({
                ...props,
                fontSize: "14px",
                backgroundColor: isSelected ? "#0DAD8E" : "white",
                "&:active": {
                  backgroundColor: "rgba(13, 173, 142, 0.5)",
                },
                "@media(max-width: 576px)": {
                  fontSize: "12px",
                },
              }),
            }}
          />
        )}
      />

      <small className="text-red">{error?.message}</small>
    </div>
  )
}
